import Reactions from 'hb-react/frontoffice/components/Reactions';
import { useTogglePostLike } from 'hb-react/shared/apps/News/NewsPublished/hooks/useTogglePostLike';

const NewsReactions = ({ id, likes }) => {
  const { togglePostLike } = useTogglePostLike();
  // TODO: update this to `Communications::News` when migration of flag-ev-news-revamp is complete
  const railsType = 'Communication';

  return (
    <Reactions
      key={id}
      displayCommentsByDefault
      id={id}
      initialLikes={likes}
      onTogglePostLike={togglePostLike}
      type={railsType}
      railsType={railsType}
    />
  );
};

export default NewsReactions;
